import '../../i18n';
import {useTranslation} from 'react-i18next';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FILE_BLUE } from '../../appearance/Colors';
import './ErrorScreen.scss';
import { useQuery } from "@apollo/client";
import { QUERY } from "../../gql-operations";

import { useHistory } from 'react-router-dom';

function ErrorPage() {
    const {t: lnT} = useTranslation();

    let history = useHistory();

    const { loading, error, data } = useQuery(QUERY.ME, {
        onCompleted: res => {
            if (res){
                console.log('this is res', res)
                if (res.me){
                    history.push('/login')
                }
            }
        }
    });

    return (
        <div
            style={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                padding: 20
            }}
        >
            <div style={{}}>
                <h4 style={{ fontSize: 24, fontWeight: '600', color: '#333333' }}>{lnT('errors:ourServiceIsCurrentlyDown')}</h4>
                <h4 style={{ fontSize: 24, fontWeight: '600', color: '#333333' }}>{lnT('errors:weLlBeBackAsSoonAs')}</h4>
                <h4 style={{ fontSize: 24, fontWeight: '600', color: '#333333' }}>{lnT('errors:thanks')}</h4>

                <br></br>
                <h4 style={{ fontSize: 20, fontWeight: '500', color: '#333333' }}>{lnT('errors:youCanAlwaysShootUsAnEmail')}<br></br>
                    <span style={{ textDecoration: 'underline' }}>{lnT('errors:supportLuckynoteIo')}</span>
                </h4>
                <br></br>

                <a href={'/'} style={{ fontSize: 20, fontWeight: '600', color: FILE_BLUE }}>{lnT('errors:reload')}</a>
            </div>
        </div>
    );
}

export default ErrorPage;
